export default "__VITE_ASSET__DLhgTi89__"